import moment from 'moment-timezone'

const DEFAULT_TZ = 'America/Chicago'

// RM-162 — client-side projection of the request expiration time for display.
// Mirrors lib/reservationExpiration.js:
//   - non-Preferred restaurant present → fixed 48h window
//   - all-Preferred → the member's chosen window (24h default / 48h)
//   - in every case the request can't outlast the reservation time
//   - rounded up to the nearest 5 minutes
// The real value is finalized at submission, so this is an exact projection from
// `now`. `now` is injectable for deterministic tests.
export function projectedRequestExpiration(reservation, restaurants, tz, now) {
  if (!reservation || !reservation.date || !reservation.preferredTime) return null
  const list = Array.isArray(restaurants) ? restaurants : []
  if (!list.length) return null

  const timeZone = tz || DEFAULT_TZ

  // Normalize the date first — reservation.date may be a full datetime string,
  // not 'YYYY-MM-DD'. Concatenating it raw misparses the time (the request then
  // shows an expiration a few minutes past the reservation). Mirrors the
  // within-48h normalization in EditReservationDialog.vue.
  const dateOnly = moment(reservation.date).format('YYYY-MM-DD')
  const reservationMoment = moment.tz(`${dateOnly} ${reservation.preferredTime}`, 'YYYY-MM-DD h:mma', timeZone)
  if (!reservationMoment.isValid()) return null

  const hasNonPreferred = list.some(r => r && r.status !== 'Preferred')
  const expirationHours = hasNonPreferred ? 48 : (reservation.requestExpirationHours === 48 ? 48 : 24)
  const candidate = (now ? now.clone() : moment()).add(expirationHours, 'hours')
  let exp = reservationMoment.isSameOrAfter(candidate) ? candidate : reservationMoment.clone()

  const roundedMinutes = Math.ceil(exp.minutes() / 5) * 5
  exp = exp.clone().minutes(roundedMinutes).seconds(0).milliseconds(0)

  return exp
}

export function projectedRequestExpirationLabel(reservation, restaurants, tz, now) {
  const exp = projectedRequestExpiration(reservation, restaurants, tz, now)

  return exp ? exp.format('ddd, MMM D · h:mma') : ''
}
